<template>
  <div class="data_brain_wrap">
    <el-row class="card_wrap" type="flex">
      <div style="height: 6%; display: flex; align-items: center; width: 100%">
        <el-breadcrumb
          separator-class="el-icon-arrow-right"
          style="font-size: 2.6ch; font-weight: 700; color: #111">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/qiye' }">
            找企业
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{ qydetail.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div
        style="
          display: flex;
          width: 100%;
          height: 92%;
          align-items: center;
          justify-content: space-around;
          flex-direction: column;
        ">
        <div
          style="
            width: 100%;
            height: 12%;
            background-color: #fff;
            display: flex;
            padding: 1vw;
            border-radius: 1vw;
            align-items: center;
          ">
          <div style="width: 5vw; height: 5vw; margin-right: 2vw">
            <img
              :src="qydetail.logo"
              alt=""
              style="width: 100%; height: 100%; border-radius: 1vw" />
          </div>
          <div
            style="
              height: 5vw;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            ">
            <div style="display: flex; align-items: center">
              <div
                style="
                  font-weight: 600;
                  font-size: 3ch;
                  color: #111;
                  margin-right: 1vw;
                ">
                {{ qydetail.name }}
              </div>
              <div style="width: 3vw; height: 1.4vw">
                <img
                  :src="qydetail.vipImage"
                  alt=""
                  style="width: 100%; height: 100%" />
              </div>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                font-weight: 600;
                font-size: 1.8ch;
                color: #2b2f7d;
              ">
              <div
                style="
                  padding: 0.2vw 0.4vw;
                  background-color: #e1eefe;
                  margin-right: 0.5vw;
                  border-radius: 0.2vw;
                ">
                主营
              </div>
              <div
                style="margin-right: 0.5vw"
                v-for="(item1, index1) in qydetail.cidName?.split(',')"
                :key="index1">
                {{ item1 }}
              </div>
            </div>
            <div style="display: flex; align-items: center">
              <div
                style="width: 4vw; height: 1.2vw; margin-right: 0.5vw"
                v-for="(item2, index2) in qydetail.labelImages"
                :key="index2">
                <img :src="item2" alt="" style="width: 100%; height: 100%" />
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            width: 100%;
            height: 20%;
            background-color: #fff;
            padding: 1vw;
            border-radius: 1vw;
            display: flex;
			flex-direction: column;
          "
          v-html="qydetail.content"></div>
        <div
          style="
            width: 100%;
            height: 66%;
            background-color: #fff;
            padding: 1vw;
            border-radius: 1vw;
          ">
          <div
            v-if="qyshop.length == 0"
            style="
              height: 46vw;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 4ch;
              font-weight: 700;
            ">
            暂无商品
          </div>
          <div
            style="
              height: 46vw;
              width: 100%;
              display: flex;
              overflow-y: scroll;
              flex-wrap: wrap;
            "
            v-else>
            <div
              style="width: 22%; margin: 15px 1% 1% 15px"
              v-for="(item, index) in qyshop"
              :key="index">
              <div class="imgbox">
                <el-image
                  :src="item.pic"
                  style="height: 100%; width: 100%"
                  :preview-src-list="pics"></el-image>
              </div>
              <div style="font-size: 2.4ch; color: #111; font-weight: 600">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div
            style="
              position: absolute;
              bottom: 2vw;
              display: flex;
              width: 100%;
              justify-content: center;
            ">
            <el-pagination
              v-if="total>8"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              :total="total"
              layout="total, prev, pager, next, jumper"
              background></el-pagination>
          </div>
        </div>
        
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getlist,
  getlistType,
  getlistDetail,
  getlistShop,
} from "@/api/user.js";
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 8, // 每页显示的卡片数量
      total:0,
      qiyeData: [],
      content: "",
      cid: 0,
      qiyeType: [],
      qydetail: [],
      qyshop: [],
      qytypes: [],
      pics: [],
    };
  },
  props: ["id"],
  mounted() {
    console.log(this.id);
  },
  computed: {
    filteredQiyeData() {
      // 根据 filterActive 的值来过滤 qiyeData
      return this.qiyeData.filter(
        (item) => item.label_ids && item.label_ids.trim() !== ""
      );
    },
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      const that = this;
      getlistDetail({ id: that.id }).then((res) => {
        that.qydetail = res.data.business;
        console.log(res);
        // 解析并转换为整数数组
        // let cids = that.qydetail.cid.split(",").map(Number);
        // // 创建一个空数组用于存储匹配的名字
        // let names = [];

        // // 遍历cids数组并在qiyeType中查找匹配项
        // cids.forEach((cid) => {
        //   let match = that.qiyeType.find((type) => type.id === cid);
        //   if (match) {
        //     names.push(match.name); // 如果找到了匹配项，就把名字加入到names数组
        //   }
        // });
        // that.qytypes = names;
        // // 输出结果
        // console.log(names);
      });
      this.getProduct();
    },
    getProduct(){
      let param = {
        page:this.currentPage,
        limit:this.pageSize,
        search:{
          bid: this.id
        }
      };
      getlistShop(param).then((res) => {
        this.qyshop = res.data;
        this.total = res.count;
        console.log(res);
        this.pics=this.qyshop.map(item=>item.pic)
      });
    },
    // 处理每页显示条目数变化
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
      this.getProduct();
    },
    // 处理当前页码变化
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.getProduct();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  font-size: 2ch !important;
  color: #828689 !important;
  font-weight: 600 !important;
  text-align: left !important;
}
.data_brain_wrap {
  padding: 70px 0;
  background: #f4f6f5;
  // text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }

  .card_wrap {
    width: 90%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    height: 1600px;
    border-radius: 8px;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .imgbox {
      width: 100%;
      height: 19vw;
      margin-bottom: 1vw;
    }
    .card {
      width: 19%;
      height: 100%;
      display: flex;
      flex-direction: column;
      background-color: #fff;
      // padding: 1%;
      justify-content: space-between;
      ::v-deep .el-carousel {
        height: 100%;

        .el-carousel__container {
          height: 100%;
        }
      }
      .cardInfo {
        padding: 1vw;
        width: 100%;
        height: 20%;
        background: linear-gradient(to bottom right, #ffffff, #94c0fe);
        display: flex;
        flex-direction: column;
        align-items: center;
        .cardTop {
          display: flex;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
        }
        .cardBody {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
          .fabu {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
        .cardBottom {
          margin-bottom: 1vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;
          .cardlist {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 30%;
            margin-bottom: 1vw;
          }
        }
        .loginout {
          width: 60%;
          height: 2vw;
          background-color: #f3f5f4;
          text-align: center;
          line-height: 2vw;
          font-size: 2ch;
          font-weight: 600;
          color: #b0b3b7;
          border-radius: 2%;
        }
      }
      .newslist {
        width: 100%;
        height: 14%;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
      .newNews {
        width: 100%;
        height: 88%;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .page-content {
      width: 100%;
      height: 100%;
      padding: 5px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .fenlei {
        width: 100%;
        padding: 20px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .fenleilist {
          height: 2.5vw;
          width: 6vw;
          text-align: center;
          line-height: 2.5vw;
          background-color: #0d067e;
          color: #fff;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
    .ggw {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 10%;
      width: 4%;
      margin-right: 1%;
    }
    .top-left {
      height: 100%;
      width: 20%;
      background-color: #0d067e;
      display: flex;
      flex-direction: column;
      border-radius: 6px;
      .top-left-title {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        color: #fff;
        padding: 10px 20px;
        font-weight: 700;
        font-size: 16px;
      }
      .top-left-info {
        width: 100%;
        flex: 1;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        background-color: #fff;
        padding: 30px 20px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .top-center {
      height: 100%;
      width: 50%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg {
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100px;
        height: 30px;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
